import React from 'react';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import MuiInputAdornment, { InputAdornmentProps as MuiInputAdornmentProps } from '@material-ui/core/InputAdornment';
import { lighten } from '@material-ui/core/styles/colorManipulator';
import classnames from 'classnames';

import Typography from './Typography';

const styles = ({
  spacing: { unit },
  custom: {
    palette: { colorSupportPowder },
  },
}: Theme) =>
  createStyles({
    colorSupportPowder: {
      background: lighten(colorSupportPowder, 0.38),
      borderRight: `1px solid ${colorSupportPowder}`,
      // WORKAROUND Use padding instead of margin in order to show the background
      marginLeft: 0,
      paddingLeft: unit * 2,
    },
    readOnly: {
      overflow: 'initial',
    },
  });

export interface InputAdornmentProps extends Omit<MuiInputAdornmentProps, 'classes'>, WithStyles<typeof styles> {
  color?: 'supportPowder';
  readOnly?: boolean;
}

const InputAdornment: React.FC<InputAdornmentProps> = ({ classes, className, color, readOnly, ...rest }) => {
  if (readOnly) {
    return (
      <Typography className={classes.readOnly} variant="bW600F15" noWrap>
        {rest.children}:
      </Typography>
    );
  }
  return (
    <MuiInputAdornment
      className={classnames(
        {
          [classes.colorSupportPowder]: color === 'supportPowder',
          [classes.readOnly]: readOnly,
        },
        className,
      )}
      {...rest}
    />
  );
};

export default withStyles(styles)(InputAdornment);
